import { forwardRef, useEffect, useRef } from "react";
import { OptionsContentWrapper } from "./ScrollableWrapper.styles";

const ScrollableWrapper = forwardRef((props, ref) => {
  const slider = useRef(null);

  useEffect(() => {
    const sliderElement = slider.current;
    if (!sliderElement) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    const handleMouseDown = (e) => {
      isDown = true;
      sliderElement.classList.add("active");
      startX = e.pageX - sliderElement.offsetLeft;
      scrollLeft = sliderElement.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      sliderElement.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      sliderElement.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - sliderElement.offsetLeft;
      const walk = (x - startX) * 3;
      sliderElement.scrollLeft = scrollLeft - walk;
    };

    sliderElement.addEventListener("mousedown", handleMouseDown);
    sliderElement.addEventListener("mouseleave", handleMouseLeave);
    sliderElement.addEventListener("mouseup", handleMouseUp);
    sliderElement.addEventListener("mousemove", handleMouseMove);

    return () => {
      sliderElement.removeEventListener("mousedown", handleMouseDown);
      sliderElement.removeEventListener("mouseleave", handleMouseLeave);
      sliderElement.removeEventListener("mouseup", handleMouseUp);
      sliderElement.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <OptionsContentWrapper className="scrollable-wrapper" ref={slider}>
      {props.children}
    </OptionsContentWrapper>
  );
});

export default ScrollableWrapper;
